import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { USER_DASHBOARD_QUERY_KEYS } from '@/api/user-dashboard/queries';
import { queryClient } from '@/app/providers/react-query-provider';
import CheckCircleIcon from '@/assets/svg/ui-elements/check-circle-green.svg';
import { Spinner, Typography } from '@/design-system';
import { PagePaths } from '@/routes/page-paths';
import { colors } from '@/shared/design-system/colors';

export const KYC_COMPLETE_MESSAGE_TYPE = 'KYC_COMPLETE';

const KycComplete = () => {
  const navigate = useNavigate();
  const [isInIframe, setIsInIframe] = useState(false);

  useEffect(() => {
    // Invalidate user profile to refresh KYC status
    queryClient.invalidateQueries({ queryKey: [USER_DASHBOARD_QUERY_KEYS.userProfile] });

    // Check if running inside iframe
    const inIframe = window.self !== window.top;
    setIsInIframe(inIframe);

    if (inIframe) {
      // Send message to parent window (KycStartModal)
      window.parent.postMessage({ type: KYC_COMPLETE_MESSAGE_TYPE }, window.location.origin);
    } else {
      // Direct navigation - redirect to settings after short delay
      const timer = setTimeout(() => {
        navigate(PagePaths.settings);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [navigate]);

  return (
    <Stack
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="24px"
      minHeight="300px"
      px="16px"
    >
      <CheckCircleIcon width={64} height={64} />
      <Typography variant="h4" fontWeight={500} align="center">
        KYC Verification Complete
      </Typography>
      <Typography color={colors.text.secondary} align="center">
        Your identity verification has been submitted successfully.
      </Typography>
      {!isInIframe && (
        <Stack alignItems="center" gap="8px">
          <Spinner />
          <Typography variant="body3" color={colors.text.secondary}>
            Redirecting to settings...
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default KycComplete;
